import { Injectable } from '@angular/core';
import { AlertProvider } from '../../services/alert/alert';

var validate = require('validate.js');

@Injectable()
export class ValidateProvider {
  params = {};
  errors = {};
  constraints = {};

  constructor(public alertProvider: AlertProvider) {
    // console.log('Hello ValidateProvider Provider');
    // console.log('---!!!!----');
    // validate.validators.currentTab = function (value, options, key, attributes) {
    //   console.log(value);
    //   console.log(options);
    //   console.log(key);
    //   console.log(attributes);
    //   return null;
    // };
  }

  clearError(prop) {
    console.info('clearing error:' + prop);
    this.errors[prop] = false;
  }

  hasError(prop) {
    if (this.errors[prop]) {
      return true;
    } else {
      return false;
    }
  }

  async validateData() {
    //clear errors
    this.errors = {};

    let validationResult = validate(this.params, this.constraints, {
      fullMessages: false,
      format: 'detailed',
    });

    if (validationResult) {
      // let firstKey = Object.keys(validationResult)[0]

      // let firstVal = validationResult[firstKey][0]

      this.errors[validationResult[0].attribute] = true;
      console.error('validation error');
      // console.error(validationResult)

      await this.alertProvider.showError(validationResult[0].error);
      return Promise.reject(validationResult[0]);
    } else {
      return;
    }
  }
}
